import React, { useState } from "react"
import DeliveryEnterpriseModal from "./DeliveryEnterpriseModal"
import DeliveryDateModal from "./DeliveryDateModal"
import DeliveryDistributionModal from "./DeliveryDistributionModal"

const initialData = { enterpriseId: "", week: "", daySlots: [], slots: [] }

const DeliveryMenuForm = ({ open, onClose, onSubmit, enterprises = [], availableDCs = [], onGoToSettings }) => {
  const [step, setStep] = useState(1)
  const [formData, setFormData] = useState(initialData)

  const handleClose = () => { setStep(1); setFormData(initialData); onClose() }

  const handleEnterpriseSubmit = ({ enterpriseId, week }) => {
    const isSameWeek = week === formData.week
    setFormData((prev) => ({
      ...prev,
      enterpriseId,
      week,
      daySlots: isSameWeek ? prev.daySlots : [],
      slots: isSameWeek ? prev.slots : [],
    }))
    setStep(2)
  }

  const handleDateSubmit = (daySlots) => {
    const existing = formData.slots
    const slots = daySlots.flatMap(({ date, count }) => {
      const prev = existing.filter((s) => s.date === date)
      return Array.from({ length: count }, (_, i) => ({ date, dcId: (prev[i] && prev[i].dcId) || "" }))
    })
    setFormData((prev) => ({ ...prev, daySlots, slots }))
    setStep(3)
  }

  const handleDistributionSubmit = async (slots) => {
    await onSubmit({ ...formData, slots })
    setStep(1)
    setFormData(initialData)
  }

  return (
    <>
      <DeliveryEnterpriseModal
        open={open && step === 1}
        onClose={handleClose}
        onCancel={handleClose}
        enterprises={enterprises}
        onGoToSettings={onGoToSettings}
        initialValues={{ enterpriseId: formData.enterpriseId, week: formData.week }}
        onSubmit={handleEnterpriseSubmit}
      />
      <DeliveryDateModal
        open={open && step === 2}
        onClose={handleClose}
        onCancel={() => setStep(1)}
        week={formData.week}
        initialDaySlots={formData.daySlots}
        onSubmit={handleDateSubmit}
      />
      <DeliveryDistributionModal
        open={open && step === 3}
        onClose={handleClose}
        onCancel={() => setStep(2)}
        enterpriseId={formData.enterpriseId}
        enterprises={enterprises}
        availableDCs={availableDCs}
        initialSlots={formData.slots}
        onSubmit={handleDistributionSubmit}
      />
    </>
  )
}

export default DeliveryMenuForm
